/* eslint-disable no-underscore-dangle */
import React from 'react';
import VisitorTrackingOriginStep from './VisitorTrackingOriginStep';
import BillingoWizardStep from './BillingoWizardStep';
import StornoModal from '../../../Components/Billingo/StornoModal';
import isInvoicingEnabled from '../../../Utils/partnerInvoicing';

// Declarative post-save steps for the booking edit flow. After a booking is
// saved, every step whose `shouldRun(ctx)` is true runs in order (the runner in
// OrderInputModal advances on each step's onComplete/onSkip), then the modal
// closes. To add a new post-save hook, append one entry here — nothing else to
// wire up.
//
//   ctx = { saved, order, partner, isNew, justCancelled, fetchOrders }
//   api = { next, showCloseWarning, setShowCloseWarning }
//
// `overlay: true` renders the step as its own modal on top of the (still-open)
// edit modal; otherwise the step replaces the edit-modal body.
// `confirmClose: true` makes the edit modal warn before closing on that step.
export const POST_SAVE_STEPS = [
  {
    key: 'visitor_tracking_origin',
    confirmClose: true,
    shouldRun: (ctx) => ctx.isNew
      && !!ctx.saved?._id
      && ctx.partner?.visitor_tracking_step === 1
      && !ctx.saved?.visitor_tracking?.token,
    render: (ctx, api) => (
      <VisitorTrackingOriginStep
        bookingId={ctx.saved._id}
        onComplete={api.next}
        showCloseWarning={api.showCloseWarning}
        setShowCloseWarning={api.setShowCloseWarning}
      />
    ),
  },
  {
    key: 'billingo_document',
    shouldRun: (ctx) => ctx.isNew && !!ctx.saved?._id && !!ctx.partner
      && isInvoicingEnabled(ctx.partner),
    render: (ctx, api) => (
      <BillingoWizardStep
        booking={ctx.saved}
        partner={ctx.partner}
        onComplete={api.next}
        onSkip={api.next}
      />
    ),
  },
  {
    key: 'storno_on_cancel',
    overlay: true,
    shouldRun: (ctx) => ctx.justCancelled && isInvoicingEnabled(ctx.partner),
    render: (ctx, api) => (
      <StornoModal
        order={ctx.saved || ctx.order}
        show
        onHide={api.next}
        onDone={ctx.fetchOrders}
      />
    ),
  },
];

// The steps that apply to a given save, in order.
export const activePostSaveSteps = (ctx) => POST_SAVE_STEPS.filter((s) => s.shouldRun(ctx));
